import React from 'react';
import { Phone, MessageCircle, Calendar, ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';
interface ActionSuggestionProps {
  type: 'call' | 'message' | 'invite';
  studentName: string;
  reason: string;
}
export function ActionSuggestion({
  type,
  studentName,
  reason
}: ActionSuggestionProps) {
  const config = {
    call: {
      icon: Phone,
      title: 'Ligar para o aluno',
      color: 'bg-blue-100 text-blue-600',
      action: 'Registrar Ligação'
    },
    message: {
      icon: MessageCircle,
      title: 'Enviar mensagem motivacional',
      color: 'bg-green-100 text-green-600',
      action: 'Abrir WhatsApp'
    },
    invite: {
      icon: Calendar,
      title: 'Convidar para evento especial',
      color: 'bg-purple-100 text-purple-600',
      action: 'Enviar Convite'
    }
  };
  const {
    icon: Icon,
    title,
    color,
    action
  } = config[type];
  return <div className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm" data-id="element-22">
      <div className="flex items-start gap-4 mb-4" data-id="element-23">
        <div className={`p-3 rounded-lg ${color}`} data-id="element-24">
          <Icon size={24} data-id="element-25" />
        </div>
        <div data-id="element-26">
          <h4 className="font-bold text-gray-900" data-id="element-27">{title}</h4>
          <p className="text-sm text-gray-600 mt-1" data-id="element-28">
            Motivo: <span className="font-medium" data-id="element-29">{reason}</span>
          </p>
        </div>
      </div>
      <div className="flex justify-end" data-id="element-30">
        <Button variant="outline" size="sm" rightIcon={<ArrowRight size={16} data-id="element-32" />} data-id="element-31">
          {action}
        </Button>
      </div>
    </div>;
}